export const ChevronLeft = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.6488 25.3648L11.3512 15.9546L20.6153 6.63523" stroke="currentColor" stroke-width="2"/>
</svg>`;
